import { Box, Button } from '@mui/joy';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import IconButton, { iconButtonClasses } from '@mui/joy/IconButton';
import { FC, JSX } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  totalPages: number;
};

export const Pagination: FC<Props> = ({
  page,
  setPage,
  totalPages,
}): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Box
      className="Pagination-laptopUp"
      sx={{
        pt: 2,
        gap: 1,
        [`& .${iconButtonClasses.root}`]: { borderRadius: '50%' },
        display: {
          xs: 'none',
          md: 'flex',
        },
      }}
    >
      <Button
        size="sm"
        variant="outlined"
        color="neutral"
        startDecorator={<KeyboardArrowLeftIcon />}
        disabled={page === 1}
        onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
      >
        {t('Previous')}
      </Button>

      <Box sx={{ flex: 1 }} />
      {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
        <IconButton
          key={p}
          size="sm"
          variant={p === page ? 'solid' : 'outlined'}
          color={p === page ? 'primary' : 'neutral'}
          aria-current={p === page ? 'page' : undefined}
          onClick={() => setPage(p)}
        >
          {p}
        </IconButton>
      ))}
      <Box sx={{ flex: 1 }} />
      <Button
        size="sm"
        variant="outlined"
        color="neutral"
        disabled={page === totalPages}
        endDecorator={<KeyboardArrowRightIcon />}
        onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
      >
        {t('Next')}
      </Button>
    </Box>
  );
};
